import SearchIcon from '@mui/icons-material/Search';
import SearchOffIcon from '@mui/icons-material/SearchOff';
import { IconButton, Input } from "@mui/material";
import axiosInstance from "axiosInstance";
import Link from "next/link";
import { useRouter } from "next/router";
import { useEffect, useRef, useState } from "react";
import LoaderScreen from "../Common/LoaderScreen";

function AllProjects() {
  const router = useRouter();
  const [loading, setLoading] = useState(true);
  const { type = "All farms" } = router.query;
  const [projects, setProjects] = useState([]);
  const [filteredProjects, setFilteredProjects] = useState([]);
  const [activeFilter, setActiveFilter] = useState(type); // Default filter
  const [searchQuery, setSearchQuery] = useState("");
  const [expanded, setExpanded] = useState(false);
  const inputRef = useRef(null);


  useEffect(() => {
    const fetchData = async () => {
      try {
        const response = await axiosInstance.get("/api/projects/all-projects");
        const activeProjects = response.data.projects.filter(pro => pro.active);
        setProjects(activeProjects);
        setLoading(false);
      } catch (error) {
        console.error(error);
        setLoading(false);
      }
    };

    fetchData();
  }, []);


  useEffect(() => {
    const filterProjects = () => {
      let filtered = projects;

      if (activeFilter !== "All farms") {
        filtered = filtered.filter(
          (project) => project.projectType === activeFilter && project.active
        );
      }

      if (searchQuery.trim() !== "") {
        filtered = filtered.filter((project) =>
          project.projectName.toLowerCase().includes(searchQuery.toLowerCase())
        );
      }

      setFilteredProjects(filtered);
    };

    filterProjects();
  }, [projects, activeFilter, searchQuery]);


  const handleClickOutside = (event) => {
    if (inputRef.current && !inputRef.current.contains(event.target)) {
      setExpanded(false);
    }
  };

  useEffect(() => {
    document.addEventListener('click', handleClickOutside);
    return () => {
      document.removeEventListener('click', handleClickOutside);
    };
  }, []);

  const goBack = () => {
    router.back();
  };

  const handleFilterClick = (filter) => {
    setActiveFilter(filter);
  };
  const handleSearchChange = (e) => {
    setSearchQuery(e.target.value);
  };
  const handleSearchClick = () => {
    setExpanded(!expanded);
  };
  if (loading) {
    // Show the loader screen when data is loading
    return (
      <LoaderScreen />
    );
  }

  return (
    <>
      <section className="topBar">
        <div className="left-wrrow" onClick={goBack}>
          <span className="iconWrapper">
            <svg
              width="6"
              height="12"
              viewBox="0 0 6 12"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M5.46849 0.414376C5.79194 0.673133 5.84438 1.1451 5.58562 1.46855L1.96044 6.00003L5.58562 10.5315C5.84438 10.855 5.79194 11.3269 5.46849 11.5857C5.14505 11.8444 4.67308 11.792 4.41432 11.4685L0.414321 6.46855C0.195189 6.19464 0.195189 5.80542 0.414321 5.53151L4.41432 0.531506C4.67308 0.20806 5.14505 0.155619 5.46849 0.414376Z"
                fill="#333333"
              />
            </svg>
          </span>
        </div>
        <div className="middleContent">
          <h3>All Farms</h3>
        </div>
        <div className="middleContent">
          <div className="searchBar">
            <div
              className={`searchBar ${expanded ? "expanded" : ""}`}
              style={{ display: "flex", alignItems: "center", height: "100%" }}
            >
              <IconButton onClick={handleSearchClick} style={{ marginTop: "0" }}>
                {expanded ? <SearchOffIcon /> : <SearchIcon />}
              </IconButton>
              {expanded && (
                <Input
                  type="text"
                  placeholder="Search projects"
                  value={searchQuery}
                  onChange={handleSearchChange}
                  sx={{
                    fontSize: "12px",
                    width: "100px", // Adjust the width value to your preference
                  }}
                  inputProps={{
                    style: {
                      fontSize: "12px",
                      paddingLeft: "8px", // Adjust the padding value to your preference
                    },
                  }}
                />
              )}
            </div>
          </div>
        </div>
      </section>
      <section className="headerGap"></section>
      <section className="menuProject">
        <ul className="scrollMenu">
          <li className="scrollMenu-list">
            <a
              href="#"
              className={`scrollMenu-link ${activeFilter === "All farms" ? "active" : ""}`}
              onClick={() => handleFilterClick("All farms")}
            >
              All farms
            </a>
          </li>
          <li className="scrollMenu-list">
            <a
              href="#"
              className={`scrollMenu-link ${activeFilter === "Short term" ? "active" : ""}`}
              onClick={() => handleFilterClick("Short term")}
            >
              Short term
            </a>
          </li>
          <li className="scrollMenu-list">
            <a
              href="#"
              className={`scrollMenu-link ${activeFilter === "Long Term" ? "active" : ""}`}
              onClick={() => handleFilterClick("Long Term")}
            >
              Long term
            </a>
          </li>
          <li className="scrollMenu-list">
            <a
              href="#"
              className={`scrollMenu-link ${activeFilter === "Shariah" ? "active" : ""}`}
              onClick={() => handleFilterClick("Shariah")}
            >
              Shariah
            </a>
          </li>
          <li className="scrollMenu-list">
            <a
              href="#"
              className={`scrollMenu-link ${activeFilter === "Fixed return" ? "active" : ""}`}
              onClick={() => handleFilterClick("Fixed return")}
            >
              Fixed return{" "}
            </a>
          </li>
        </ul>
      </section>
      {/* Render the filtered projects */}
      <section className="allProjects">
        {filteredProjects.map((project) => (
          <Link href={`/project/${project.slug}`} key={project._id} className="singleProject">
            <div className="singleProject-left">
              <figure className="singleProject-thumb">
                <img src={project.thumbnailImage} alt="project image " />
              </figure>
            </div>
            <div className="singleProject-right">
              <h3 className="projectName">{project.projectName}</h3>
              <p className="price">
                {project.perShareCost.toLocaleString()} <span>/Unit</span>
              </p>
              <div className="roi">
                <span className="icon">
                  <svg
                    width="17"
                    height="17"
                    viewBox="0 0 17 17"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <path
                      d="M8.12257 1.19674C8.3219 0.967322 8.6781 0.967322 8.87743 1.19674L9.93918 2.41873C10.2786 2.80937 10.7954 2.99747 11.3065 2.91639L12.9053 2.66277C13.2055 2.61515 13.4783 2.84412 13.4836 3.14799L13.5114 4.76656C13.5203 5.28398 13.7953 5.76026 14.239 6.02668L15.6268 6.8601C15.8873 7.01657 15.9492 7.36736 15.7578 7.6035L14.7388 8.86131C14.413 9.2634 14.3175 9.80501 14.4861 10.2943L15.0135 11.8248C15.1125 12.1121 14.9344 12.4206 14.6361 12.4785L13.0469 12.787C12.5389 12.8856 12.1176 13.2391 11.9323 13.7223L11.3525 15.2337C11.2437 15.5175 10.909 15.6393 10.6432 15.4919L9.22753 14.7068C8.77498 14.4558 8.22502 14.4558 7.77247 14.7068L6.35681 15.4919C6.09103 15.6393 5.75631 15.5175 5.64746 15.2337L5.0677 13.7223C4.88236 13.2391 4.46106 12.8856 3.95306 12.787L2.36391 12.4785C2.06556 12.4206 1.88746 12.1121 1.98647 11.8248L2.51388 10.2943C2.68247 9.80501 2.58697 9.2634 2.26121 8.86131L1.24215 7.6035C1.05083 7.36736 1.11269 7.01657 1.37323 6.8601L2.76103 6.02668C3.20467 5.76026 3.47965 5.28398 3.48856 4.76656L3.51642 3.14799C3.52165 2.84412 3.79452 2.61515 4.09468 2.66277L5.69351 2.91639C6.20461 2.99747 6.72141 2.80937 7.06082 2.41873L8.12257 1.19674Z"
                      stroke="#FF5660"
                      stroke-linecap="round"
                      stroke-linejoin="round"
                    />
                    <path
                      d="M11.5599 5.43994L5.43994 11.5599"
                      stroke="#FF5660"
                      stroke-width="0.75"
                      stroke-linecap="round"
                    />
                    <circle
                      cx="6.80012"
                      cy="6.79987"
                      r="1.055"
                      stroke="#FF5660"
                      stroke-width="0.75"
                    />
                    <circle cx="10.2" cy="10.2" r="1.055" stroke="#FF5660" stroke-width="0.75" />
                  </svg>
                </span>
                <span className="text">
                  {project.projectType === "Shariah" ? (
                    <>
                      {project.rateOfInterestMin}% - {project.rateOfInterestMax}%
                    </>
                  ) : (
                    <>{project.rateOfInterestMin}%</>
                  )}
                </span>
              </div>
              <div className="date">
                <span className="icon">
                  <svg
                    width="12"
                    height="15"
                    viewBox="0 0 12 15"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <path
                      d="M1.33333 14.0503C0.966667 14.0503 0.652667 13.9198 0.391333 13.6589C0.130444 13.3976 0 13.0836 0 12.7169V3.38359C0 3.01692 0.130444 2.70314 0.391333 2.44225C0.652667 2.18092 0.966667 2.05025 1.33333 2.05025H2V0.716919H3.33333V2.05025H8.66667V0.716919H10V2.05025H10.6667C11.0333 2.05025 11.3473 2.18092 11.6087 2.44225C11.8696 2.70314 12 3.01692 12 3.38359V12.7169C12 13.0836 11.8696 13.3976 11.6087 13.6589C11.3473 13.9198 11.0333 14.0503 10.6667 14.0503H1.33333ZM1.33333 12.7169H10.6667V6.05025H1.33333V12.7169ZM1.33333 4.71692H10.6667V3.38359H1.33333V4.71692ZM6 8.71692C5.81111 8.71692 5.65289 8.65292 5.52533 8.52492C5.39733 8.39736 5.33333 8.23914 5.33333 8.05025C5.33333 7.86136 5.39733 7.70292 5.52533 7.57492C5.65289 7.44736 5.81111 7.38358 6 7.38358C6.18889 7.38358 6.34733 7.44736 6.47533 7.57492C6.60289 7.70292 6.66667 7.86136 6.66667 8.05025C6.66667 8.23914 6.60289 8.39736 6.47533 8.52492C6.34733 8.65292 6.18889 8.71692 6 8.71692ZM3.33333 8.71692C3.14444 8.71692 2.986 8.65292 2.858 8.52492C2.73044 8.39736 2.66667 8.23914 2.66667 8.05025C2.66667 7.86136 2.73044 7.70292 2.858 7.57492C2.986 7.44736 3.14444 7.38358 3.33333 7.38358C3.52222 7.38358 3.68067 7.44736 3.80867 7.57492C3.93622 7.70292 4 7.86136 4 8.05025C4 8.23914 3.93622 8.39736 3.80867 8.52492C3.68067 8.65292 3.52222 8.71692 3.33333 8.71692ZM8.66667 8.71692C8.47778 8.71692 8.31956 8.65292 8.192 8.52492C8.064 8.39736 8 8.23914 8 8.05025C8 7.86136 8.064 7.70292 8.192 7.57492C8.31956 7.44736 8.47778 7.38358 8.66667 7.38358C8.85556 7.38358 9.01378 7.44736 9.14133 7.57492C9.26933 7.70292 9.33333 7.86136 9.33333 8.05025C9.33333 8.23914 9.26933 8.39736 9.14133 8.52492C9.01378 8.65292 8.85556 8.71692 8.66667 8.71692ZM6 11.3836C5.81111 11.3836 5.65289 11.3196 5.52533 11.1916C5.39733 11.064 5.33333 10.9058 5.33333 10.7169C5.33333 10.528 5.39733 10.3698 5.52533 10.2423C5.65289 10.1143 5.81111 10.0503 6 10.0503C6.18889 10.0503 6.34733 10.1143 6.47533 10.2423C6.60289 10.3698 6.66667 10.528 6.66667 10.7169C6.66667 10.9058 6.60289 11.064 6.47533 11.1916C6.34733 11.3196 6.18889 11.3836 6 11.3836ZM3.33333 11.3836C3.14444 11.3836 2.986 11.3196 2.858 11.1916C2.73044 11.064 2.66667 10.9058 2.66667 10.7169C2.66667 10.528 2.73044 10.3698 2.858 10.2423C2.986 10.1143 3.14444 10.0503 3.33333 10.0503C3.52222 10.0503 3.68067 10.1143 3.80867 10.2423C3.93622 10.3698 4 10.528 4 10.7169C4 10.9058 3.93622 11.064 3.80867 11.1916C3.68067 11.3196 3.52222 11.3836 3.33333 11.3836ZM8.66667 11.3836C8.47778 11.3836 8.31956 11.3196 8.192 11.1916C8.064 11.064 8 10.9058 8 10.7169C8 10.528 8.064 10.3698 8.192 10.2423C8.31956 10.1143 8.47778 10.0503 8.66667 10.0503C8.85556 10.0503 9.01378 10.1143 9.14133 10.2423C9.26933 10.3698 9.33333 10.528 9.33333 10.7169C9.33333 10.9058 9.26933 11.064 9.14133 11.1916C9.01378 11.3196 8.85556 11.3836 8.66667 11.3836Z"
                      fill="#FF5660"
                    />
                  </svg>
                </span>
                <span className="text">{project.totalDuration.split(" ").slice(0, 2).join(' ')} </span>
              </div>
              <Link href={`/project/${project.slug}`} className="btnVisit">
                Visit
              </Link>
            </div>
          </Link>
        ))}
        {filteredProjects.length == 0 && (
          <>
            <div>
              <div className="search-empty">
                <span className="icon">
                  <svg
                    width="150"
                    height="143"
                    viewBox="0 0 150 143"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <path
                      fill-rule="evenodd"
                      clip-rule="evenodd"
                      d="M117.147 42.7547C133.07 62.448 150.844 80.8958 149.127 97.5258C147.444 114.122 126.202 128.9 105.869 134.489C85.5028 140.043 66.0451 136.408 46.2844 128.665C26.5574 120.956 6.52738 109.14 1.37681 92.3079C-3.74009 75.5096 6.02242 53.6618 20.4642 34.305C34.906 14.982 54.0271 -1.8836 70.5897 0.169895C87.186 2.18973 101.224 23.095 117.147 42.7547Z"
                      fill="#12BA5A"
                      fill-opacity="0.05"
                    />
                    <circle cx="21.8466" cy="117.785" r="1.56049" fill="#00B90C" />
                    <circle cx="93.6252" cy="119.865" r="2.60082" fill="#FF4D62" />
                    <ellipse cx="66.5793" cy="3.34838" rx="2.60082" ry="2.60082" fill="#F9BA45" />
                    <path
                      fill-rule="evenodd"
                      clip-rule="evenodd"
                      d="M45.0321 39.6887C45.0036 39.687 44.9751 39.6853 44.9464 39.6836C43.2852 39.5871 41.6258 39.6313 39.968 39.8161C39.7558 39.8398 39.5659 39.7855 39.3983 39.6533C39.2306 39.521 39.1336 39.349 39.1073 39.1371C39.1071 39.1355 39.1069 39.1338 39.1067 39.1321C39.1065 39.1305 39.1063 39.1288 39.1061 39.1272C39.0822 38.913 39.1375 38.7218 39.2721 38.5535C39.4066 38.3852 39.5809 38.2891 39.7951 38.2653C41.5705 38.0673 43.3478 38.0226 45.1271 38.1311C45.3422 38.1442 45.5211 38.2315 45.6639 38.3928C45.8067 38.5542 45.8715 38.7424 45.8584 38.9574C45.8453 39.1725 45.7581 39.3514 45.5967 39.4942C45.4354 39.637 45.2472 39.7018 45.0321 39.6887ZM29.2318 42.2689C29.2325 42.2704 29.2333 42.272 29.234 42.2735C29.2348 42.275 29.2355 42.2765 29.2363 42.278C29.2821 42.3688 29.3433 42.4477 29.4199 42.5146C29.4965 42.5814 29.583 42.6314 29.6791 42.6645C29.777 42.6982 29.8775 42.7119 29.9808 42.7055C30.0841 42.6992 30.1822 42.6733 30.2752 42.6279C31.7966 41.8854 33.372 41.2779 35.0014 40.8055C35.2064 40.746 35.361 40.6231 35.4652 40.4367C35.5693 40.2503 35.593 40.0542 35.5362 39.8484C35.5357 39.8468 35.5353 39.8452 35.5348 39.8436C35.5344 39.842 35.5339 39.8404 35.5335 39.8388C35.5046 39.7394 35.4579 39.6493 35.3932 39.5685C35.3286 39.4878 35.2509 39.4224 35.1603 39.3725C35.0697 39.3226 34.9729 39.292 34.8701 39.2806C34.7672 39.2692 34.6661 39.2779 34.5668 39.3067C32.8514 39.8041 31.1928 40.4437 29.5908 41.2255C29.3972 41.32 29.2653 41.4691 29.1952 41.6729C29.1251 41.8766 29.1373 42.0753 29.2318 42.2689ZM21.0084 48.5583C21.0096 48.5595 21.0108 48.5607 21.012 48.5618C21.0132 48.563 21.0144 48.5642 21.0157 48.5653C21.0896 48.6352 21.1739 48.6886 21.2687 48.7255C21.3635 48.7625 21.4617 48.7802 21.5634 48.7787C21.6669 48.7771 21.7661 48.7558 21.8611 48.7148C21.9561 48.6738 22.0396 48.6162 22.1117 48.542C23.2912 47.327 24.5662 46.2232 25.9367 45.2306C26.0205 45.1699 26.0895 45.0955 26.1437 45.0073C26.1979 44.9192 26.2332 44.8241 26.2495 44.7219C26.2655 44.6214 26.2621 44.5217 26.2392 44.4226C26.2162 44.3235 26.1754 44.2324 26.1168 44.1493C26.1159 44.1479 26.1149 44.1465 26.1139 44.1451C26.1129 44.1437 26.1119 44.1424 26.1109 44.141C25.9846 43.9665 25.815 43.8622 25.6022 43.8282C25.3895 43.7942 25.1959 43.8404 25.0214 43.9668C23.5776 45.0124 22.2345 46.1752 20.992 47.455C20.8419 47.6096 20.7685 47.7946 20.7717 48.0101C20.7749 48.2255 20.8538 48.4082 21.0084 48.5583ZM15.3775 57.2763C15.379 57.277 15.3806 57.2777 15.3821 57.2784C15.3836 57.2791 15.3852 57.2798 15.3867 57.2805C15.5821 57.3665 15.7795 57.3716 15.979 57.2956C16.1785 57.2196 16.3226 57.0844 16.4112 56.8902C17.0179 55.5598 17.7227 54.2765 18.5254 53.0405C18.6503 52.848 18.7775 52.6571 18.9067 52.4677C19.0271 52.2914 19.0681 52.0981 19.0299 51.8881C18.9916 51.678 18.8851 51.5117 18.7103 51.3891C18.7089 51.3881 18.7075 51.3872 18.7062 51.3862C18.7048 51.3853 18.7034 51.3844 18.7021 51.3834C18.5241 51.262 18.3293 51.2212 18.1175 51.2612C17.9058 51.3011 17.7392 51.4101 17.6178 51.5881C17.4819 51.7872 17.3481 51.9881 17.2166 52.1906C16.3719 53.4913 15.6301 54.842 14.9914 56.2427C14.9484 56.3368 14.9251 56.4356 14.9215 56.539C14.9179 56.6424 14.9341 56.7425 14.9703 56.8395C15.0066 56.9364 15.0599 57.0227 15.1305 57.0984C15.201 57.1741 15.2834 57.2334 15.3775 57.2763ZM13.0307 67.3692C13.0324 67.3693 13.0341 67.3695 13.0358 67.3696C13.0374 67.3697 13.0391 67.3698 13.0408 67.3699C13.1423 67.3769 13.2413 67.3645 13.3379 67.3327C13.4346 67.3009 13.5216 67.2521 13.5992 67.1862C13.678 67.1192 13.7411 67.0397 13.7883 66.9477C13.8355 66.8556 13.8633 66.758 13.8717 66.6549C14.0094 64.9656 14.2911 63.3024 14.7168 61.6652C14.7706 61.4586 14.744 61.2629 14.6371 61.0782C14.5302 60.8934 14.3738 60.7728 14.1679 60.7163C14.1663 60.7159 14.1647 60.7155 14.163 60.715C14.1614 60.7146 14.1597 60.7142 14.1581 60.7137C13.9496 60.6595 13.7524 60.6869 13.5666 60.796C13.3808 60.9051 13.2608 61.0639 13.2066 61.2725C12.7581 62.997 12.4614 64.7489 12.3164 66.5282C12.2989 66.7429 12.3599 66.9324 12.4994 67.0966C12.6389 67.2609 12.816 67.3517 13.0307 67.3692ZM13.8963 71.7162C13.877 71.5036 13.7857 71.3284 13.6226 71.1907C13.4594 71.053 13.2715 70.9924 13.0586 71.009C13.0569 71.0091 13.0553 71.0093 13.0536 71.0094C13.0519 71.0095 13.0503 71.0097 13.0486 71.0098C12.9456 71.0192 12.8482 71.0479 12.7566 71.096C12.665 71.1441 12.5861 71.2079 12.5198 71.2874C12.4536 71.3668 12.4051 71.456 12.3743 71.5548C12.3435 71.6535 12.3328 71.7545 12.3422 71.8575C12.5037 73.6335 12.8154 75.3831 13.2773 77.1063C13.3331 77.3144 13.4543 77.4723 13.6409 77.58C13.8275 77.6877 14.0249 77.7137 14.233 77.6579C14.2346 77.6575 14.2362 77.657 14.2378 77.6566C14.2394 77.6561 14.241 77.6557 14.2426 77.6552C14.3406 77.6276 14.4297 77.5826 14.51 77.5201C14.5903 77.4577 14.6559 77.3824 14.7067 77.2943C14.7584 77.2047 14.791 77.1086 14.8045 77.006C14.818 76.9034 14.8114 76.8022 14.7846 76.7022C14.3458 75.0652 14.0497 73.4032 13.8963 71.7162ZM18.9212 86.9008C18.9203 86.9015 18.9194 86.9021 18.9184 86.9028C18.9175 86.9034 18.9165 86.9041 18.9156 86.9047C18.7381 87.0268 18.5434 87.0683 18.3315 87.0291C18.1196 86.9899 17.9527 86.8815 17.8306 86.704C17.0673 85.5942 16.3184 84.4009 15.584 83.1242C15.5805 83.1181 15.5771 83.112 15.5738 83.1059C15.5705 83.0997 15.5672 83.0935 15.5641 83.0873C15.4022 82.7672 15.2459 82.4444 15.0952 82.1187C15.0047 81.9232 14.9965 81.7243 15.0708 81.5221C15.1451 81.3198 15.28 81.1734 15.4755 81.0829C15.477 81.0822 15.4785 81.0815 15.4801 81.0808C15.4816 81.0801 15.4831 81.0794 15.4847 81.0788C15.5775 81.0372 15.6748 81.0147 15.7764 81.0112C15.8781 81.0077 15.9767 81.0235 16.0722 81.0586C16.1693 81.0942 16.2559 81.1471 16.332 81.2172C16.4081 81.2873 16.4679 81.3693 16.5113 81.4632C16.6515 81.7662 16.7968 82.0665 16.9472 82.3643C17.6574 83.5979 18.3804 84.7497 19.1163 85.8197C19.175 85.905 19.215 85.9982 19.2366 86.0994C19.2581 86.2006 19.2595 86.3021 19.2407 86.4038C19.2221 86.5044 19.1851 86.5977 19.1298 86.6837C19.0745 86.7697 19.005 86.8421 18.9212 86.9008L18.9212 86.9008ZM21.7434 89.5837C21.6417 89.5794 21.5429 89.5944 21.4471 89.6287C21.3513 89.6631 21.2654 89.7142 21.1896 89.7822C21.1884 89.7832 21.1872 89.7843 21.186 89.7854C21.1848 89.7864 21.1836 89.7875 21.1824 89.7886C21.0238 89.9343 20.9398 90.1149 20.9307 90.3301C20.9215 90.5454 20.9898 90.7324 21.1356 90.8911C22.4217 92.2913 23.7458 93.4794 25.1078 94.4554C25.1919 94.5156 25.2843 94.5575 25.3851 94.581C25.4859 94.6045 25.5873 94.6078 25.6894 94.5909C25.7915 94.5741 25.8864 94.5383 25.9743 94.4837C26.0622 94.429 26.1362 94.3597 26.1965 94.2756C26.1979 94.2736 26.1994 94.2715 26.2008 94.2695C26.2022 94.2675 26.2036 94.2654 26.205 94.2634C26.3255 94.0883 26.3674 93.896 26.3308 93.6867C26.2942 93.4773 26.1895 93.3107 26.0167 93.1869C24.7422 92.2736 23.4982 91.1565 22.2849 89.8355C22.2149 89.7593 22.133 89.6993 22.0392 89.6557C21.9453 89.6121 21.8467 89.5881 21.7434 89.5837ZM29.8037 95.5214C29.7138 95.5655 29.6353 95.6248 29.5683 95.6992C29.5012 95.7735 29.4504 95.8577 29.4157 95.9516C29.4146 95.9547 29.4135 95.9577 29.4124 95.9607C29.4114 95.9637 29.4103 95.9667 29.4093 95.9698C29.3397 96.1737 29.3525 96.3723 29.4475 96.5657C29.5425 96.7591 29.6919 96.8906 29.8959 96.9601C31.5739 97.5325 33.299 97.8186 35.0714 97.8186C35.2868 97.8186 35.4707 97.7425 35.6231 97.5901C35.7754 97.4378 35.8516 97.2539 35.8516 97.0384C35.8516 96.8485 35.7904 96.6809 35.6681 96.5357C35.5457 96.3904 35.3909 96.3017 35.2038 96.2695C35.1819 96.2657 35.1599 96.2629 35.1378 96.261C35.1157 96.2591 35.0935 96.2582 35.0714 96.2582C33.4716 96.2581 31.9143 95.9998 30.3996 95.4832C30.3017 95.4498 30.2011 95.4364 30.0979 95.443C29.9946 95.4496 29.8965 95.4757 29.8037 95.5214Z"
                      fill="#757575"
                    />
                    <rect
                      width="9.36295"
                      height="2.08066"
                      rx="1.04033"
                      transform="matrix(0.981627 -0.190809 -0.190809 -0.981627 127.159 20.595)"
                      fill="#757575"
                    />
                    <rect
                      x="119.708"
                      y="10.405"
                      width="9.36295"
                      height="2.08066"
                      rx="1.04033"
                      transform="rotate(-60 119.708 10.405)"
                      fill="#757575"
                    />
                    <rect
                      x="124.219"
                      y="13.7998"
                      width="9.36295"
                      height="2.08066"
                      rx="1.04033"
                      transform="rotate(-40 124.219 13.7998)"
                      fill="#757575"
                    />
                    <path
                      fill-rule="evenodd"
                      clip-rule="evenodd"
                      d="M125.363 23.9862V90.2157C125.363 95.9613 120.705 100.619 114.959 100.619H62.4228C56.6772 100.619 52.0195 95.9613 52.0195 90.2157V21.0339C52.0195 15.2883 56.6772 10.6306 62.4228 10.6306H113.24"
                      fill="#12BA5A"
                    />
                    <path
                      fill-rule="evenodd"
                      clip-rule="evenodd"
                      d="M118.079 29.1879V95.4174C118.079 101.163 113.422 105.821 107.676 105.821H55.1396C49.394 105.821 44.7363 101.163 44.7363 95.4174V26.2356C44.7363 20.49 49.394 15.8323 55.1396 15.8323H105.957V17.3928L55.1396 17.3928C52.6977 17.3928 50.6135 18.2561 48.8868 19.9828C47.1602 21.7094 46.2968 23.7937 46.2968 26.2356L46.2968 95.4174C46.2968 97.8592 47.1602 99.9435 48.8868 101.67C50.6135 103.397 52.6977 104.26 55.1396 104.26H107.676C110.118 104.26 112.202 103.397 113.929 101.67C115.656 99.9435 116.519 97.8592 116.519 95.4174V29.1879H118.079Z"
                      fill="#333333"
                    />
                    <path
                      fill-rule="evenodd"
                      clip-rule="evenodd"
                      d="M117.737 28.2953C117.8 28.3666 117.848 28.4467 117.882 28.5358C117.916 28.6248 117.933 28.7169 117.933 28.8121C117.933 29.0276 117.857 29.2115 117.704 29.3638C117.552 29.5162 117.368 29.5924 117.152 29.5924H108.554C107.388 29.5924 106.417 29.1572 105.642 28.2869C104.866 27.4167 104.545 26.4025 104.679 25.2444L105.674 16.6187C105.685 16.5231 105.713 16.4326 105.758 16.3473C105.802 16.2619 105.861 16.1874 105.933 16.1236C106.01 16.0551 106.098 16.004 106.196 15.9703C106.293 15.9367 106.394 15.923 106.497 15.9294C106.601 15.9357 106.699 15.9616 106.792 16.007C106.885 16.0523 106.965 16.1138 107.034 16.1913L117.737 28.2953ZM107.024 18.5359L115.421 28.032H108.553C107.854 28.032 107.272 27.771 106.806 27.2489C106.341 26.7267 106.148 26.1183 106.229 25.4235L107.024 18.5359Z"
                      fill="#263238"
                    />
                    <rect
                      x="56.1816"
                      y="31.9575"
                      width="31.2098"
                      height="1.56049"
                      rx="0.780246"
                      fill="white"
                    />
                    <rect
                      x="56.1816"
                      y="41.8406"
                      width="41.6131"
                      height="1.56049"
                      rx="0.780246"
                      fill="white"
                    />
                    <rect
                      x="56.1816"
                      y="51.7236"
                      width="55.1374"
                      height="1.56049"
                      rx="0.780246"
                      fill="white"
                    />
                    <rect
                      x="56.1816"
                      y="61.6067"
                      width="55.1374"
                      height="1.56049"
                      rx="0.780246"
                      fill="white"
                    />
                    <rect
                      x="56.1816"
                      y="91.2561"
                      width="55.1374"
                      height="1.56049"
                      rx="0.780246"
                      fill="white"
                    />
                    <rect
                      x="56.1816"
                      y="71.4897"
                      width="55.1374"
                      height="1.56049"
                      rx="0.780246"
                      fill="white"
                    />
                    <rect
                      x="56.1816"
                      y="81.373"
                      width="55.1374"
                      height="1.56049"
                      rx="0.780246"
                      fill="white"
                    />
                    <circle cx="47.8606" cy="95.937" r="21.8469" fill="#F8F8F8" />
                    <ellipse cx="44.2188" cy="98.5379" rx="16.1251" ry="16.1251" fill="#FF5660" />
                    <rect
                      x="58.8135"
                      y="107.104"
                      width="1.56049"
                      height="6.24197"
                      rx="0.780246"
                      transform="rotate(-45 58.8135 107.104)"
                      fill="#757575"
                    />
                    <path
                      fill-rule="evenodd"
                      clip-rule="evenodd"
                      d="M64.3299 110.414L63.2258 111.518C62.8196 111.924 62.6165 112.414 62.6165 112.989C62.6165 113.563 62.8196 114.053 63.2258 114.46L69.8471 121.081C70.2533 121.487 70.7436 121.69 71.318 121.69C71.8924 121.69 72.3827 121.487 72.7889 121.081L73.893 119.977C74.2992 119.571 74.5023 119.08 74.5023 118.506C74.5023 117.931 74.2992 117.441 73.893 117.035L67.2717 110.414C66.8655 110.007 66.3752 109.804 65.8008 109.804C65.2264 109.804 64.7361 110.007 64.3299 110.414ZM64.3284 113.356C64.0835 113.111 64.0835 112.866 64.3284 112.621L65.4326 111.517C65.6776 111.272 65.9225 111.272 66.1675 111.517L72.7888 118.139C73.0338 118.384 73.0338 118.628 72.7888 118.873L71.6847 119.978C71.4397 120.223 71.1947 120.223 70.9498 119.978L64.3284 113.356Z"
                      fill="#2E2E2E"
                    />
                    <path
                      fill-rule="evenodd"
                      clip-rule="evenodd"
                      d="M59.1791 83.9315C65.4764 90.2287 65.4764 100.439 59.1791 106.736C52.8819 113.033 42.672 113.033 36.3748 106.736C30.0776 100.439 30.0776 90.2287 36.3748 83.9315C42.672 77.6342 52.8819 77.6342 59.1791 83.9315ZM62.3407 95.3339C62.3407 99.3558 60.9187 102.789 58.0748 105.633C55.2309 108.477 51.798 109.899 47.7761 109.899C43.7542 109.899 40.3213 108.477 37.4774 105.633C34.6335 102.789 33.2115 99.3558 33.2115 95.3339C33.2115 91.312 34.6335 87.8791 37.4774 85.0352C40.3213 82.1913 43.7542 80.7693 47.7761 80.7693C51.798 80.7693 55.2309 82.1913 58.0748 85.0352C60.9187 87.8791 62.3407 91.312 62.3407 95.3339Z"
                      fill="#333333"
                    />
                    <rect
                      x="53.4453"
                      y="89.5002"
                      width="1.56049"
                      height="16.6452"
                      rx="0.780246"
                      transform="rotate(45 53.4453 89.5002)"
                      fill="#2E2E2E"
                    />
                    <rect
                      width="1.56049"
                      height="16.6452"
                      rx="0.780246"
                      transform="matrix(-0.707107 0.707107 0.707107 0.707107 42.7842 89.4995)"
                      fill="#2E2E2E"
                    />
                  </svg>
                </span>
                <h3 className="empty-title">No Filter or Search Results</h3>
                <p className="empty-text">We cannot find the item you are looking for.</p>
              </div>
            </div>
          </>
        )}
      </section>
      <section className="headerGap"></section>
    </>
  );
}

export default AllProjects;
